import script from "./AulasReposicaoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AulasReposicaoModal.vue?vue&type=script&setup=true&lang=js"

import "./AulasReposicaoModal.vue?vue&type=style&index=0&id=bef8197a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bef8197a"]])

export default __exports__